import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'

//import { VRButton } from 'three/examples/jsm/webxr/VRButton.js';


import * as TWEEN from "@tweenjs/tween.js";
import Stats from 'stats.js'
import { gsap } from 'gsap'
import * as dat from 'dat.gui'
import { MeshBasicMaterial } from 'three'




/**
 * Base
 */
// Debug
const gui = new dat.GUI()
gui.closed = true
gui.hide()


const stats = new Stats()
stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
//document.body.appendChild(stats.dom)

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Overlay
 */
const overlayGeometry = new THREE.PlaneGeometry(5, 5, 5, 5)
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms:
    {
        //set to 1 when you activate the loader 
        uAlpha: { value: 1 }
    },
    vertexShader: `
        void main()
        {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;
        void main()
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
        }
    `
})
const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)


/**
 * Models & Loaders
 */

//Loading Manager
const loadingBarElement = document.querySelector('.loading-bar')

let initialLoad = null
let isMobileSize = null
let objectsRaycaster = []

const loadingManager = new THREE.LoadingManager(
    // Loaded
    () =>
    {   
        window.setTimeout(() =>
        {
            console.log('loaded')
            gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0 })
            loadingBarElement.classList.add('ended')
            loadingBarElement.style.transform = ''
            initialLoad = 1
            
            //Select objects for raycaster
            objectsRaycaster.push(model_scene.children[1].children[3].children[1].children[0])
            objectsRaycaster.push(model_scene.children[1].children[9].children[1].children[0])
            objectsRaycaster.push(model_scene.children[1].children[15].children[1].children[0])
            objectsRaycaster.push(model_scene.children[1].children[21].children[1].children[0])
            objectsRaycaster.push(model_scene.children[1].children[27].children[1].children[0])
            objectsRaycaster.push(model_scene.children[1].children[1].children[0]) 
            objectsRaycaster.push(model_scene.children[1].children[33].children[0])  
            objectsRaycaster.push(model_scene.children[1].children[34].children[0])   
            objectsRaycaster.push(model_scene.children[1].children[35].children[0])
            objectsRaycaster.push(model_scene.children[1].children[36].children[0])   
            objectsRaycaster.push(model_scene.children[1].children[37].children[0]) 
        },500)
    },

    // Progress

    (itemUrl, itemsLoaded, itemsTotal) =>
    {
        if(!initialLoad){
        const progressRatio = itemsLoaded / itemsTotal
        loadingBarElement.style.transform = `scaleX(${progressRatio})`
        }
    }
)



const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('draco/')

const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)
let model_scene

/**
 * Video Textures
 */
/** 
let video1 = document.createElement( 'video' );
video1.src = "textures/assets/videos/1_Diavolo_video.mp4"
video1.muted = true
video1.load() // must call after setting/changing source
//video1.play()
video1.loop = true
var texture1 = new THREE.VideoTexture( video1 )
texture1.minFilter = THREE.LinearFilter
texture1.magFilter = THREE.LinearFilter
texture1.format = THREE.RGBFormat
texture1.flipY = false


let video2 = document.createElement( 'video' );
video2.src = "textures/assets/videos/2_Giganti_video.mp4"
video2.muted = true
video2.load() // must call after setting/changing source
//video2.play()
video2.loop = true
var texture2 = new THREE.VideoTexture( video2 )
texture2.minFilter = THREE.LinearFilter
texture2.magFilter = THREE.LinearFilter
texture2.format = THREE.RGBFormat
texture2.flipY = false

let video3 = document.createElement( 'video' );
video3.src = "textures/assets/videos/3_Amore_video.mp4"
video3.muted = true
video3.load() // must call after setting/changing source
//video3.play()
video3.loop = true
var texture3 = new THREE.VideoTexture( video3 )
texture3.minFilter = THREE.LinearFilter
texture3.magFilter = THREE.LinearFilter
texture3.format = THREE.RGBFormat
texture3.flipY = false

let video4 = document.createElement( 'video' );
video4.src = "textures/assets/videos/4_Inferno_video.mp4"
video4.muted = true
video4.load() // must call after setting/changing source
//video4.play()
video4.loop = true
var texture4 = new THREE.VideoTexture( video4 )
texture4.minFilter = THREE.LinearFilter
texture4.magFilter = THREE.LinearFilter
texture4.format = THREE.RGBFormat
texture4.flipY = false
*/

let video5 = document.createElement( 'video' );
video5.src = "textures/assets/videos/5_Anime_video.mp4"
video5.muted = true
video5.crossOrigin = "anonymous"
video5.playsInline = true
video5.load() // must call after setting/changing source
video5.play()
//video5.pause()
video5.loop = true
//video5.preload = "metadata"
//video5.poster = 'textures/assets/5_Le-Anime_Thumbnail.jpg'
var texture5 = new THREE.VideoTexture( video5 )
texture5.minFilter = THREE.LinearFilter
texture5.magFilter = THREE.LinearFilter
texture5.format = THREE.RGBFormat
texture5.flipY = false
const Frame5MaterialVideo = new THREE.MeshBasicMaterial({map: texture5})

var tex5 = new THREE.TextureLoader(loadingManager).load('textures/assets/5_Le-Anime_Thumbnail.jpg');
tex5.flipY = false; // for glTF models.
const Frame5Material = new THREE.MeshBasicMaterial({map: tex5})

gltfLoader.load(
    'models/Inferno_Draco_v6.gltf',
    (gltf) =>
    {   
        //model_scene = gltf.scene.children[1].children[3].children[1].children[0] //artwork1
        //model_scene.children[1].children[3].children[1].children[0] //artwork1
        //loading scene and thumbnail textures artworks
        model_scene = gltf.scene

        console.log(model_scene)

        model_scene.traverse(function (node) {
    
            if ( node.isMesh || node.isLight ) node.castShadow = true;
            if ( node.isMesh || node.isLight ) node.receiveShadow = true;
        
          });

        
        //model_scene.children[1].children[3].children[1].children[0].receiveShadow = false;
        //model_scene.children[1].children[3].children[1].children[0].material.map = texture5
        //model_scene.children[1].children[3].children[1].children[0].material.emissiveMap  = null
        //model_scene.children[1].children[3].children[1].children[0].material.emissiveIntensity = 0
        //model_scene.children[1].children[3].children[1].children[0].material.metalness = 0

        
        
        model_scene.children[1].children[3].children[1].children[0].material = Frame5MaterialVideo
        //model_scene.children[1].children[3].children[1].children[0].needsUpdate = true
        //video5.pause()
        
        
        //model_scene.children[1].children[3].children[1].children[0].lightMapIntensity = 1
        //model_scene.children[1].children[3].children[1].children[0].material.color = 0xffffff

        var tex4 = new THREE.TextureLoader(loadingManager).load('textures/assets/4_Inferno_Thumbnail.jpg');
        tex4.flipY = false; // for glTF models.
        //model_scene.children[1].children[9].children[1].children[0].receiveShadow = false;
        //model_scene.children[1].children[9].children[1].children[0].material.map = texture4
        //model_scene.children[1].children[9].children[1].children[0].material.emissiveIntensity = 0
        //model_scene.children[1].children[9].children[1].children[0].material.metalness = 0

        const Frame4Material = new THREE.MeshBasicMaterial({map: tex4})
        model_scene.children[1].children[9].children[1].children[0].material = Frame4Material

        var tex3 = new THREE.TextureLoader(loadingManager).load('textures/assets/3_Amore_Thumbnail.jpg');
        tex3.flipY = false; // for glTF models.
        //model_scene.children[1].children[15].children[1].children[0].receiveShadow = false;
        //model_scene.children[1].children[15].children[1].children[0].material.map = texture3
        //model_scene.children[1].children[15].children[1].children[0].material.emissiveIntensity = 0
        //model_scene.children[1].children[15].children[1].children[0].material.metalness = 0

        const Frame3Material = new THREE.MeshBasicMaterial({map: tex3})
        model_scene.children[1].children[15].children[1].children[0].material = Frame3Material

        var tex2 = new THREE.TextureLoader(loadingManager).load('textures/assets/2_Giganti_Thumbnail.jpg');
        tex2.flipY = false; // for glTF models.
        //model_scene.children[1].children[21].children[1].children[0].receiveShadow = false;
        //model_scene.children[1].children[21].children[1].children[0].material.map = texture2
        //model_scene.children[1].children[21].children[1].children[0].material.emissiveIntensity = 0
        //model_scene.children[1].children[21].children[1].children[0].material.metalness = 0

        const Frame2Material = new THREE.MeshBasicMaterial({map: tex2})
        model_scene.children[1].children[21].children[1].children[0].material = Frame2Material

        var tex1 = new THREE.TextureLoader(loadingManager).load('textures/assets/1_Diavolo_Thumbnail.jpg');
        tex1.flipY = false; // for glTF models.
        //model_scene.children[1].children[27].children[1].children[0].receiveShadow = false;
        //model_scene.children[1].children[27].children[1].children[0].material.map = texture1
        //model_scene.children[1].children[27].children[1].children[0].material.emissiveIntensity = 0
        //model_scene.children[1].children[27].children[1].children[0].material.metalness = 0

        const Frame1Material = new THREE.MeshBasicMaterial({map: tex1})
        model_scene.children[1].children[27].children[1].children[0].material = Frame1Material


        
        //model_scene.scale.set(0.01,0.01,0.01)
        scene.add(model_scene)
        //while(gltf.scene.children.length)
        //{
        //    scene.add(gltf.scene.children[0])
        //}
    }
)




/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader(loadingManager)

const animeColorTexture1 = textureLoader.load('textures/assets/anime/hq/1.jpg')

const frameColorTexture = textureLoader.load('textures/assets/anime/1.jpg')
const frameColorTexture2 = textureLoader.load('textures/assets/anime/2.jpg')
const frameColorTexture3 = textureLoader.load('textures/assets/anime/3.jpg')
const frameColorTexture4 = textureLoader.load('textures/assets/anime/4.jpg')
const frameColorTexture5 = textureLoader.load('textures/assets/anime/5.jpg')
const frameColorTexture6 = textureLoader.load('textures/assets/anime/6.jpg')
const frameColorTexture7 = textureLoader.load('textures/assets/anime/7.jpg')
const frameColorTexture8 = textureLoader.load('textures/assets/anime/8.jpg')
const frameColorTexture9 = textureLoader.load('textures/assets/anime/9.jpg')
const frameColorTexture10 = textureLoader.load('textures/assets/anime/10.jpg')
// Open Edition Frame
//used MeshBasicMaterial to Ignore Light!
const oeFrameGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.01)
const oeFrameMaterial = new THREE.MeshBasicMaterial({
    map: animeColorTexture1,

})

const oeFrame = new THREE.Mesh(oeFrameGeometry, oeFrameMaterial)
oeFrame.position.set(0, 10, 15) 
//oeFrame.rotation.y= (0.2*Math.PI)
scene.add(oeFrame)

const oeBgGeometry = new THREE.BoxGeometry(10, 10, 0.01)
const oeBgMaterial = new THREE.MeshBasicMaterial({
    color: 0x000000,
    transparent: true,
    opacity: 0.8,

})
const oeBg = new THREE.Mesh(oeBgGeometry, oeBgMaterial)
oeBg.position.set(0, 10, 14) 
scene.add(oeBg)



// Graves
const graves = new THREE.Group()
scene.add(graves)

const graveGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.01)
//change to MeshBasicMaterial
const graveMaterial = new THREE.MeshStandardMaterial({
    map: frameColorTexture,

})

const graveMaterial2 = new THREE.MeshStandardMaterial({
    map: frameColorTexture2,

})

const graveMaterial3 = new THREE.MeshStandardMaterial({
    map: frameColorTexture3,

})

const graveMaterial4 = new THREE.MeshStandardMaterial({
    map: frameColorTexture4,

})

const graveMaterial5 = new THREE.MeshStandardMaterial({
    map: frameColorTexture5,

})

const graveMaterial6 = new THREE.MeshStandardMaterial({
    map: frameColorTexture6,

})

const graveMaterial7 = new THREE.MeshStandardMaterial({
    map: frameColorTexture7,

})

const graveMaterial8 = new THREE.MeshStandardMaterial({
    map: frameColorTexture8,

})

const graveMaterial9 = new THREE.MeshStandardMaterial({
    map: frameColorTexture9,

})

const graveMaterial10 = new THREE.MeshStandardMaterial({
    map: frameColorTexture10,

})

const graveMatArray = [graveMaterial,graveMaterial2,graveMaterial3,graveMaterial4,graveMaterial5,graveMaterial6,graveMaterial7,graveMaterial8,graveMaterial9,graveMaterial10]

for(let i = 0; i < 70; i++)
{
    const angle = Math.random() * Math.PI * 2 // Random angle
    const radius = 13 + Math.random() * 3     // Random radius
    const x = Math.cos(angle) * radius        // Get the x position using cosinus
    const z = Math.sin(angle) * radius        // Get the z position using sinus

    // Create the mesh
    const grave = new THREE.Mesh(graveGeometry, graveMatArray[i%10])
    //grave.castShadow = true

    // Position
    grave.position.set(x, 0.6, z)                              

    // Rotation
    grave.rotation.z = (Math.random() - 0.5) * 0.4
    grave.rotation.y = (Math.random() - 0.5) * 3
    grave.position.y = (Math.random() - 0.5) * 30 + 10 

    // Add to the graves container
    graves.add(grave)
}



/**
 * Lights
 */
// Ambient light
const ambientLight = new THREE.AmbientLight('#ffffff', 1)
scene.add(ambientLight)

// Directional light
const moonLight = new THREE.DirectionalLight('#ff0000', 6)
moonLight.castShadow = true
moonLight.shadow.mapSize.width = 1024 //256
moonLight.shadow.mapSize.height = 1024 //256
moonLight.shadow.camera.far = 100
moonLight.position.set(2.9 ,8 ,1)
moonLight.target.position.set(3, 5, 1)
scene.add(moonLight)
scene.add(moonLight.target)

//gui.addColor(new ColorGUIHelper(moonLight, 'color'), 'value').name('color')
gui.add(moonLight, 'intensity', 0, 10, 0.01)
gui.add(moonLight.target.position, 'x', -10, 10)
gui.add(moonLight.target.position, 'z', -10, 10)
gui.add(moonLight.target.position, 'y', 0, 10)
gui.add(moonLight.position, 'x', -20, 20)
gui.add(moonLight.position, 'z', -20, 20)
gui.add(moonLight.position, 'y', 0, 20)



/**
 * Ghosts
 
const ghost1 = new THREE.PointLight('#ff00ff', 3, 3)
ghost1.castShadow = true
ghost1.shadow.mapSize.width = 256
ghost1.shadow.mapSize.height = 256
ghost1.shadow.camera.far = 7
//scene.add(ghost1)

const ghost2 = new THREE.PointLight('#00ffff', 3, 3)
ghost2.castShadow = true
ghost2.shadow.mapSize.width = 256
ghost2.shadow.mapSize.height = 256
ghost2.shadow.camera.far = 7
//scene.add(ghost2)

const ghost3 = new THREE.PointLight('#ff7800', 3, 3)
ghost3.castShadow = true
ghost3.shadow.mapSize.width = 256
ghost3.shadow.mapSize.height = 256
ghost3.shadow.camera.far = 7
//scene.add(ghost3)
*/

/**
 * Fog
 */
//const fog = new THREE.Fog('#262837', 20, 40)
//scene.fog = fog

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

//console.log(sizes.width)
if(sizes.width<900){
    isMobileSize = 1
}
//console.log(isMobileSize)

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    if(sizes.width<900){
        isMobileSize = 1
    }
    else {
        isMobileSize = 0
    }

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    //renderer.shadowMap.type = THREE.PCFSoftShadowMap
    
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(30, sizes.width / sizes.height, 1, 1000)

camera.position.x = 6.85
camera.position.y = 20.07
camera.position.z = 25.9
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.target = new THREE.Vector3(-1.95, 7.46, 0)

if(isMobileSize) {
    camera.position.set(25.82,23.58,35.45)
    controls.target.set(1.69,7.43,-2.14)
}

//controls.addEventListener( 'change', render );
//controls.addEventListener( 'change', render )
//controls.minPolarAngle = Math.PI * 0.1
//controls.maxPolarAngle =  Math.PI * 0.5
//.minAzimuthAngle  = -Math.PI * 0.6
//controls.maxAzimuthAngle =  Math.PI * 0.6
controls.rotateSpeed = 0.04
controls.panSpeed = 0.2
controls.zoomSpeed = 0.5
//controls.minDistance = 1.5
controls.maxDistance = 50
controls.mouseButtons = {LEFT: THREE.MOUSE.LEFT, MIDDLE: THREE.MOUSE.RIGHT, RIGHT: THREE.MOUSE.RIGHT};
controls.touches.ONE = THREE.TOUCH.PAN;
controls.touches.TWO = THREE.TOUCH.DOLLY_ROTATE; //vs 
controls.update();


/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    antialias: true,
    //physicallyCorrectLights: true,
    canvas: canvas,
    alpha: true 
})
renderer.shadowMap.enabled = true

renderer.shadowMap.type = THREE.PCFSoftShadowMap
//renderer.setClearColor('#000000')
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * VR Stuff
 */
//document.body.appendChild( VRButton.createButton( renderer ) );
//renderer.xr.enabled = true;
//renderer.xr.setReferenceSpaceType( 'viewer' );


var buttons = document.getElementsByTagName("button");
for (let i = 0; i < buttons.length; i++) {
  buttons[i].addEventListener("click", onButtonClick, false);
};

let anime_loading = document.getElementById("navigate-open")
let anime_goback = document.getElementById("go-back")
let anime_input = document.getElementById("input-anime")

function onButtonClick(event) {
  //alert(event.target.id);
  switch ( event.target.id ) {
    case "home":
        moveToHome()
        hideOpenNav()
        break
    case "go-back":
        moveToHome()
        hideOpenNav()
        break
    case "diavolo":
        moveTo1()
        hideOpenNav()
        break
    case "giganti":
        moveTo2()
        hideOpenNav()
        break
    case "amore":
        moveTo3()
        hideOpenNav()
        break
    case "inferno":
        moveTo4()
        hideOpenNav()
        break
    case "anime":
        moveTo5() 
        anime_loading.style.visibility = "visible"
        anime_loading.style.opacity = 1
        break
    case "load-oe":
        const anime_nr = anime_input.value;
        anime_goback.style.visibility = "visible"
        anime_goback.style.opacity = 1
        changeCharacter(anime_nr)
        moveToOE()
        break
  }
}

const playVideoNr = (vidNum) => {
    eval("video" + vidNum).play()
    

    //model_scene.children[1].children[3].children[1].children[0].material = Frame5MaterialVideo
}

window.addEventListener("keyup", function(event) {
    
    if (event.keyCode == 37) {
        if(currentCircle==6){
            changeCharDown()
        }
        
    }
    if (event.keyCode == 39) {
        if(currentCircle==6){
            changeCharUp()
        }
        
    }


  })

anime_input.addEventListener("keyup", function(event) {
    // Number 13 is the "Enter" key on the keyboard
    if (event.keyCode === 13) {
        // Cancel the default action, if needed
        event.preventDefault()
        // Trigger the button element with a click
        const anime_nr = anime_input.value
        changeCharacter(anime_nr)
        moveToOE()
    }

  })

const hideOpenNav = () => {
    anime_loading.style.visibility = "hidden"
    anime_loading.style.opacity = 0
    anime_goback.style.visibility = "hidden"
    anime_goback.style.opacity = 0
}

let isChanging = null;



let currentChar = 1


const changeCharacter = (char_nr) => {
    
    if (isNaN(char_nr) || char_nr < 1 || char_nr > 1573) {
        alert("The Open Edition number must be between 1 and 1573");
        
    }
    else if (!isChanging) {
        //console.log(char_nr)
        isChanging = 1
        currentChar = char_nr
        console.log(currentChar)
        if(currentChar != anime_input.value ) {
            anime_input.value = char_nr
        }
        
        
        const coords_oeFrame = { x: oeFrame.position.x, y: oeFrame.position.y, z: oeFrame.position.z };
        const coords_oeFrame2 = { x: -20, y: 10, z: 0 }
        const coords_oeFrame3 = { x: 6, y: 10, z: 13 }
        
        console.log(coords_oeFrame)
        if(currentCircle==6) {
            const A = new TWEEN.Tween(coords_oeFrame)
                .to({ x: coords_oeFrame2.x, y: coords_oeFrame2.y, z: coords_oeFrame2.z})
                .easing(TWEEN.Easing.Quadratic.In)
                .onUpdate(() =>
                oeFrame.position.set(coords_oeFrame.x, coords_oeFrame.y, coords_oeFrame.z)
            )
            .start();

            
            const C = new TWEEN.Tween(coords_oeFrame3)
                .to({ x: coords_oeFrame.x, y: coords_oeFrame.y, z: coords_oeFrame.z})
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate(() =>
                oeFrame.position.set(coords_oeFrame3.x, coords_oeFrame3.y, coords_oeFrame3.z)
            )
        A.chain(C)
        }

        
        const changeTexture = () => {
            const anime_url = "textures/assets/anime/hq/" + char_nr + ".jpg"
            console.log(anime_url) 
            const newAnimeTexture = textureLoader.load(anime_url)
            oeFrame.material.map = newAnimeTexture
        }
        setTimeout(changeTexture, 500);
        
        const resetChanging = () => {
        isChanging = 0
        }
        setTimeout(resetChanging, 2000);
        
    }
}

const changeCharUp = () => {
    const newChar = parseInt(currentChar) + 1
    changeCharacter(newChar)
}

const changeCharDown = () => {
    const newChar = parseInt(currentChar) - 1
    changeCharacter(newChar)
}

/**
 * Swipe detection
 */
canvas.addEventListener("touchstart", startTouch, false)
canvas.addEventListener("touchmove", moveTouch, false)

// Swipe Up / Down / Left / Right
var initialX = null
var initialY = null

function startTouch(e) {
  initialX = e.touches[0].clientX
  initialY = e.touches[0].clientY
}

function moveTouch(e) {
  if (initialX === null) {
    return
  }

  if (initialY === null) {
    return
  }

  var currentX = e.touches[0].clientX
  var currentY = e.touches[0].clientY

  var diffX = initialX - currentX
  var diffY = initialY - currentY

  if (Math.abs(diffX) > Math.abs(diffY)) {
    // sliding horizontally
    if (diffX > 0) {
        if(currentCircle==6){
            changeCharUp()
            moveToOE()
        }   
      // swiped left
      //console.log("swiped left")
    } else {
      // swiped right
      if(currentCircle==6){
        changeCharDown()
        moveToOE()
        }  
      //console.log("swiped right")
    }  
  } else {
    // sliding vertically
    if (diffY > 0) {
      // swiped up
      //console.log("swiped up")
    } else {
      // swiped down
      //console.log("swiped down")
    }  
  }

  initialX = null
  initialY = null

  e.preventDefault()
}

/**
 * Mouse
 */
const mouse = new THREE.Vector2()

window.addEventListener('mousemove', (event) =>
{
    mouse.x = event.clientX / sizes.width * 2 - 1
    mouse.y = - (event.clientY / sizes.height) * 2 + 1
    
    //console.log(mouse)
})

window.addEventListener('touchstart', (event) =>
{
    mouse.x = (event.changedTouches[0].clientX / sizes.width) * 2 - 1
    mouse.y = -(event.changedTouches[0].clientY / sizes.height) * 2 + 1
    
    //console.log(mouse)
})




/**
 * Raycaster
 */
const raycaster = new THREE.Raycaster()

let currentIntersect = null
let currentCircle = null
//click


const handleClick = () =>
{
    if(currentIntersect)
    {
        switch(currentIntersect.object)
        {
            case model_scene.children[1].children[27].children[1].children[0]:
                console.log('click on circle 1')
                if(currentCircle==1) {
                    moveTo1close()
                }
                else {
                    moveTo1()
                }
                break

            case model_scene.children[1].children[21].children[1].children[0]:
                console.log('click on circle 2')
                if(currentCircle==2) {
                    moveTo2close()
                }
                else {
                    moveTo2()
                }
                
                break

            case model_scene.children[1].children[15].children[1].children[0]:
                console.log('click on circle 3')
                if(currentCircle==3) {
                    moveTo3close()
                }
                else {
                    moveTo3()
                }
                
                break

            case model_scene.children[1].children[9].children[1].children[0]:
                console.log('click on circle 4')
                //document.body.style.cursor = "pointer"
                if(currentCircle==4) {
                    moveTo4close()
                }
                else {
                    moveTo4()
                }
                break

            case model_scene.children[1].children[3].children[1].children[0]:
                console.log('click on circle 5')
                if(currentCircle==5) {
                    moveTo5close()
                    //model_scene.children[1].children[3].children[1].children[0].material.transparent = true
                    //new TWEEN.Tween( model_scene.children[1].children[3].children[1].children[0].material ).to( { opacity: 0 }, 1000 ).start();
                }
                else {
                    moveTo5()
                }
                
                //moveToOE()
                anime_loading.style.visibility = "visible"
                anime_loading.style.opacity = 1
                break
            case model_scene.children[1].children[1].children[0]:
                console.log('click on see your soul')
                moveToOE()
                anime_loading.style.visibility = "visible"
                anime_loading.style.opacity = 1
                anime_goback.style.visibility = "visible"
                anime_goback.style.opacity = 1
                break
                case model_scene.children[1].children[33].children[0]:
                    console.log('On Nifty Anime')
                    openInNewTab("https://niftygateway.com/collections/toomuchlagoe")
                    break
            case model_scene.children[1].children[34].children[0]:
                    console.log('On Nifty Inferno')
                    openInNewTab("https://niftygateway.com/itemdetail/primary/0xd8d1f01b836f5717bbc5639e91d78032ebae2571/1")
                    break
            case model_scene.children[1].children[35].children[0]:
                    console.log('On Nifty Amore')
                    openInNewTab("https://niftygateway.com/itemdetail/primary/0xd8d1f01b836f5717bbc5639e91d78032ebae2571/2")
                    break
            case model_scene.children[1].children[36].children[0]:
                    console.log('On Nifty Giganti')
                    openInNewTab("https://niftygateway.com/itemdetail/primary/0xd8d1f01b836f5717bbc5639e91d78032ebae2571/3")
                    break
            case model_scene.children[1].children[37].children[0]:
                    console.log('On Nifty Diavolo')
                    openInNewTab("https://niftygateway.com/itemdetail/primary/0xd8d1f01b836f5717bbc5639e91d78032ebae2571/4")
                    break
            default:
                //document.body.style.cursor = "default"

               
        }
    }
}

//listening only on canvas so it does not interfere with button UI
canvas.addEventListener('click', handleClick)
//touchend
canvas.addEventListener('touchend',handleClick)


const openInNewTab = (url) => {
    var win = window.open(url, '_blank');
    win.focus();
  }

/**
 * functions to move to different circles
 * 
 */
const moveTo = (cx,cy,cz,tx,ty,tz) =>
{
    const coords = { x: camera.position.x, y: camera.position.y, z: camera.position.z };
    new TWEEN.Tween(coords)
        .to({ x: cx, y: cy, z: cz})
        .easing(TWEEN.Easing.Quadratic.InOut)
        .onUpdate(() =>
        camera.position.set(coords.x, coords.y, coords.z)
    )
    .start();
    const coords_target = { x: controls.target.x, y: controls.target.y, z: controls.target.z };
    new TWEEN.Tween(coords_target)
        .to({ x: tx, y: ty, z: tz})
        .easing(TWEEN.Easing.Quadratic.InOut)
        .onUpdate(() =>
        controls.target.set(coords_target.x, coords_target.y, coords_target.z)
    )
    .start();
   
}

gui.add(camera.position, 'x', -20, 200).step(0.01).name("Camera Pos X").listen()
gui.add(camera.position, 'y', -20, 20).step(0.01).name("Camera Pos Y").listen()
gui.add(camera.position, 'z', -20, 20).step(0.01).name("Camera Pos Z").listen()
gui.add(controls.target, 'x', -10, 10).step(0.01).name("Camera Target X").listen()
gui.add(controls.target, 'y', -10, 10).step(0.01).name("Camera Target Y").listen()
gui.add(controls.target, 'z', -10.0, 10.0).step(0.01).name("Camera Target Z").listen()


const moveToHome = () =>
{   
    if(!isMobileSize) {
        moveTo(6.85, 20.07,25.9,-1.95, 7.46, 0)
    }
    else {
        moveTo(25.82,23.58,35.45,1.69,7.43,-2.14)
    }
    
    currentCircle=0
}


const moveTo1 = () =>
{   
    if(!isMobileSize) {
        moveTo(9.17,2.58,1.66,-4.86,2.08,-9.55)
    }
    else {
        moveTo(12.42,8.19,13.21,-1.81,4.36,-10.59)
    }
    
    currentCircle=1
}

const moveTo1close = () =>
{   
    moveTo(5.14,1.8,-0.12,-5.66,2.23,-8.87)
    currentCircle=11
}

const moveTo2 = () =>
{   
    if(!isMobileSize) {
        moveTo(6.03,3.72,-0.76,-4.8,3.9,-9.6)
    }
    else {
        moveTo(8.56,7.66,9.5,-3.03,4.54,-9.89)
    }

    currentCircle=2
}

const moveTo2close = () =>
{   
moveTo(2.65,3.77,-2.1,-5.66,4.1,-8.75)
    currentCircle=22
}

const moveTo3 = () =>
{   

    if(!isMobileSize) {
        moveTo(4.09,6.01,-1.94,-5,6.1,-9.4)
    }
    else {
        moveTo(6,9.34,7.53,-4.19,6.59,-9.53)
    }
    
    currentCircle=3
}

const moveTo3close = () =>
{   
    moveTo(0.2,5.84,-4.02,-5.63,6.07,-8.69)
    currentCircle=33
}


const moveTo4 = () =>
{   
    if(!isMobileSize) {
        moveTo(2.34,8.32,-3.2,-5.1,8.4,-9.3)
    }
    else {
        moveTo(4.66,11.03,6.43,-5.07,9.28,-9.29)
    }
    currentCircle=4
}

const moveTo4close = () =>
{   
    moveTo(-2.34,7.91,-6.01,-5.65,7.91,-8.66)
    currentCircle=44
}


const moveTo5 = () =>
{   
    if(!isMobileSize) {
        moveTo(-0.44,10.13,-5.72,-5,10.2,-9.4)
    }
    else {
        moveTo(1.19,12.99,2.97,-6.15,11.67,-8.89)
    }

    
    currentCircle=5
    //video5.play()
}

const moveTo5close = () =>
{   
    //moveTo(-5.42,10,-8.38,-5.7,10,-8.6)
    moveTo(-4.71,9.96,-7.94,-5.65,9.96,-8.67)
    currentCircle=55
    playVideoNr(5)
}

//oeFrame.position.set(0, 10, 10) 

const moveToOE = () =>
{   
    if(!isMobileSize) {
        moveTo(0,10,16.76,0,10,15)
    }
    else {
        moveTo(0,9.90,17.73,0,9.90,15)
    }
    
    currentCircle=6
}

/**
 * Abandon hope all ye who enter here
 */


/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0
const tick = () =>
{
    stats.begin()
    const elapsedTime = clock.getElapsedTime()
    //needed for some animation
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    //Finds interesction with circles 
    raycaster.setFromCamera(mouse, camera)
    //const objectsToTest = [model_scene.children[1].children[3].children[1].children[0],model_scene.children[1].children[9].children[1].children[0]]
    const intersects = raycaster.intersectObjects(objectsRaycaster,true)

    if(intersects.length)
    {
        document.body.style.cursor = "pointer"
        if(!currentIntersect)
        {
            console.log('mouse enter')
            
        }

        currentIntersect = intersects[0]
    }
    else
    {
        document.body.style.cursor = "default"
        if(currentIntersect)
        {
            //console.log('mouse leave')
        }

        currentIntersect = null
    }

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)
    
    TWEEN.update()

    graves.rotation.y = (elapsedTime * 0.01) *Math.PI

    // Call tick again on the next frame
    //window.requestAnimationFrame(tick)
    //
    
    stats.end()
}
//tick()
renderer.setAnimationLoop(tick)